export default __webpack_public_path__ + "static/media/SylvieMemainYeComputer.5c788795.jpg";